import React, { useState } from "react";
import UserServices from "../../services/externalServices/authServices/UserServices";
import { INITIAL_USER, INITIAL_INPUT_ERROR } from "./constants";
import hampiImg from "../../assets/hampi-imgs/img8.avif";
import logo from "../../assets/imgs/Cruze_Black.png";
import { useDispatch } from "react-redux";
import { setAuthUser } from "../../redux/slices/userSlice";
import { useLocation } from "react-router-dom";

export const AuthModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isLoginRoute = location.pathname === "/login"; 
  const shouldShowModal = isOpen || isLoginRoute;

  const [step, setStep] = useState(1); // 1: Phone, 2: OTP/Password, 3: Full Name & Password
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  
  const [user, setUser] = useState(INITIAL_USER);
  const [isNewUser, setIsNewUser] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();

  // if (!isOpen) return null; // Hide modal if not open
  if (!shouldShowModal) return null;
  const getDummyDeviceDetails = () => {
    return {
      countryCode: "+91", // Default country code (you can change based on user input)
      phone_number: phoneNumber,
      device_number: "WEB-DEVICE-123456", // Dummy device number
      preferredLanguage: navigator.language || "en", // Get browser language
      lastAccessed: new Date().toISOString(), // Current timestamp
      deviceDetails: {
        browser: navigator.userAgent, // Browser info
        platform: navigator.platform, // OS info
      },
      is_tc_accepted: true, // Assume terms and conditions are accepted
    };
  };

  // Function to call API for phone number validation
  const handlePhoneSubmit = async () => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phoneNumber)) {
      setErrorMessage("Please enter a valid 10-digit phone number.");
      return;
    }
    setLoading(true);
    try {
      const requestData = getDummyDeviceDetails(); // Get dummy values

      const response = await UserServices.login(requestData); // Send data

      console.log("response", response);

      if (response.success) {
        localStorage.setItem("token", response.data.token);
        if (response.data.is_new_user) {
          setIsNewUser(true);
          setStep(2);
        } else {
          setIsNewUser(false);
          setStep(2);
        }
      } else {
        setErrorMessage(response.message || "Phone number not found.");
      }
    } catch (error) {
      setErrorMessage("Something went wrong. Please try again.");
      console.error("error", error);
    }
    setLoading(false);
  };

  console.log("step",step);
  
  // Function to send OTP
  const verifyOtp = async () => {
    const otpRegex = /^[0-9]{4}$/;
    if (!otpRegex.test(otp)) {
      setErrorMessage("OTP must be exactly 4 digits.");
      return;
    }
    setLoading(true);
    try {
      const res = await UserServices.verifyOtp({ otp: otp });
      if (res.success && isNewUser) {
        setStep(3);
      }
      else{
        setStep(5);
      }
      console.log("responsefrom verify otp", res);
    } catch (error) {
      console.log("error", error);
    }
    setLoading(false);
  };

  const register = async () => {
    const passwordRegex = /^[0-9]{4}$/;
    if (!user.first_name || !passwordRegex.test(user.password)) {
      setErrorMessage("Please enter your name and a 4-digit numeric password.");
      return;
    }
    try {
      const updatedUser = { ...user, is_active: true };
      console.log("updatedUser", updatedUser);
      const res = await UserServices.updateUser(updatedUser);
      console.log("response in register screen", res);

      if (res.success) {
        localStorage.setItem("isLoggedIn", "true");
        dispatch(setAuthUser(res.data));
        onLoginSuccess();
        // onClose();
        handleClose();
      }
    } catch (error) {
      console.log("error registering the user", error);
    }
  };

  // const comparePassword = async () => {
  //   try {
  //     const res = await UserServices.comparePassword({ password: password });
  //     console.log("res in compare password", res);
  //     if (res.success) {
  //       localStorage.setItem("isLoggedIn", "true");
  //       console.log("res.data",res.data)
  //       dispatch(setUser(res.data));

  //       onLoginSuccess();
  //       onClose();
  //     }
  //   } catch (error) {
  //     console.log("error ", error);
  //   }
  // };

  const comparePassword = async () => {
    const passwordRegex = /^[0-9]{4}$/;
    if (!passwordRegex.test(password)) {
      setErrorMessage("Password must be exactly 4 digits.");
      return;
    }
    setLoading(true);
    try {
      const res = await UserServices.comparePassword({ password });

      console.log("📌 Response from API:", res);

      if (!res || !res.success || !res.data) {
        console.error("🚨 Invalid response:", res);
        return;
      }

      console.log("✅ Dispatching user:", res.data);

      localStorage.setItem("isLoggedIn", "true");
      dispatch(setAuthUser(res.data)); // Ensure this gets a valid object

      onLoginSuccess();
      handleClose()
      // onClose();
    } catch (error) {
      console.error("❌ Error in comparePassword:", error);
    }
    setLoading(false);
  };

  const reset = () => {

    // Keyboard.dismiss();


      if (password !== confirmPassword) {
        // showError('Error', i18n.t('MPIN_CONFIRM.ERROR'))
        return
      }
      // NetworkInfoUtils.isConnected().then(({ isConnected }) => {
        // if (isConnected) {
          setLoading(true)

          UserServices.updateUser({ password: password })
            .then(async response => {
              setLoading(false)
              if (response.success) {
                // dispatch(passResetSuccess(response.data))
                // dispatch(otpSuccess())

                try {
                  // Set the user as active after successful login
                  await UserServices.updateUser({ is_active: true });
                  localStorage.setItem("isLoggedIn", "true");
                  dispatch(setAuthUser(response.data)); // Ensure this gets a valid object
            
                  onLoginSuccess();
                  // onClose();
                  handleClose()
                } catch (err) {
                  console.error('Error while setting user as active:', err);
                }

                // navigateToTemp()
                // navigate(navigationConstants.home)
              } else {
                // showError('Error', response.message)
              }
            })
            .catch(err => {
              // console.log('error==', err)
              setLoading(false)
              // showError('Error', i18n.t('SOMETHING_WENT_WRONG'));
            })
        // } else {
        //   showError('Error', i18n.t('CHECK_INTERNET'));
        // }
      // })
    
  }

  const handleClose = () => {
    if (isLoginRoute) {
      // If on /login route, navigate away instead of just closing
      window.history.back(); // Or navigate to home page
    } else {
      onClose(); // Normal close behavior
    }
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg flex flex-col md:flex-row md:h-auto mt-10 md:mt-0 relative">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-black text-2xl"
        >
          ✖
        </button>

        {/* Left Side - Image Section */}
        <div className="hidden md:flex md:w-1/2 items-center justify-center">
          <img
            src={hampiImg}
            alt="Auth Visual"
            className="w-full h-auto object-cover rounded-l-lg"
          />
        </div>

        {/* Right Side - Login Form */}
        <div className="w-full md:w-1/2 p-1 flex flex-col justify-center">
          {/* Error Message */}
          {errorMessage && (
            <p className="text-red-500 text-sm mb-4">{errorMessage}</p>
          )}

          {/* Form Inputs */}
          <form
            onSubmit={(e) => e.preventDefault()}
            className="p-6 bg-gray-800 text-white rounded-lg "
          >
            <h2 className="text-2xl font-bold text-center mb-6">
              {step === 1
                ? "Mobile number verification"
                : isNewUser
                ? "Create Your Account"
                : "Secure Login"}
            </h2>

            {/* Step 1: Enter Phone Number */}
            {step === 1 && (
              <>
                <p className="text-gray-400 text-center mb-4">
                  you will recieve an OTP through WhatsApp for verification.
                </p>
                <input
                  type="tel"
                  placeholder="Phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
                />
                <button
                  type="button"
                  onClick={handlePhoneSubmit}
                  disabled={loading} // Disable when loading
                  className={`w-full py-3 rounded-lg transition ${
                    loading
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-black hover:bg-gray-700 text-white"
                  }`}
                >
                  {loading ? "Processing..." : "Next"}
                </button>
              </>
            )}

            {/* Step 2: Enter OTP (For New Users) or Password (For Existing Users) */}
            {step === 2 && isNewUser && (
              <>
                <p className="text-gray-400 text-center mb-4">
                  We've sent an OTP to your phone. Please enter it below to
                  verify your number.
                </p>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
                />
                <button
                  type="button"
                  onClick={verifyOtp}
                  disabled={loading}
                  className={`w-full py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition ${
                    loading ? "cursor-not-allowed opacity-70" : ""
                  }`}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </>
            )}

            {step === 2 && !isNewUser && (
              <>
                <p className="text-gray-400 text-center mb-4">
                  Enter your 4 digit Password
                </p>
                <input
                  type="password"
                  placeholder="4-digit Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
                />
                <button
                  onClick={comparePassword}
                  disabled={loading}
                  className={`w-full py-3 rounded-lg transition ${
                    loading
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-black hover:bg-gray-700 text-white"
                  }`}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
                <p className="text-center mt-4">

                <button
                  onClick={()=>setStep(4)}
                  disabled={loading}
                className="text-white hover:underline"
                >
                  Forgot Password?
                </button>

                  {/* <a href="#" className="text-blue-400 hover:underline">
                    Forgot Password?
                  </a> */}
                </p>
              </>
            )}

            {/* Step 3: Enter Full Name & Password (For New Users) */}
            {step === 3 && isNewUser && (
              <>
                <p className="text-gray-400 text-center mb-4">
                  Almost there! Complete your profile by entering your full name
                  and setting up a password.
                </p>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={user.first_name}
                  onChange={(e) =>
                    setUser((prevUser) => ({
                      ...prevUser,
                      first_name: e.target.value,
                    }))
                  }
                  className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
                />
                <input
                  type="password"
                  placeholder="Create Password"
                  value={user.password}
                  onChange={(e) =>
                    setUser((prevUser) => ({
                      ...prevUser,
                      password: e.target.value,
                    }))
                  }
                  className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
                />
                <button
                  onClick={register}
                  className="w-full py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition"
                >
                  Register
                </button>
                <p className="text-center mt-4">
                  Already have an account?{" "}
                  <span
                    className="text-blue-400 cursor-pointer hover:underline"
                    onClick={() => setStep(2)}
                  >
                    Log in
                  </span>
                </p>
              </>
            )}

            {step === 4 && !isNewUser &&(
                <>
                <p className="text-gray-400 text-center mb-4">
                  We've sent an OTP to your phone. Please enter it below to
                  verify your number.
                </p>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
                />
                <button
                  type="button"
                  onClick={verifyOtp}
                  disabled={loading}
                  className={`w-full py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition ${
                    loading ? "cursor-not-allowed opacity-70" : ""
                  }`}
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </>
            )}
            {step===5&&(
              <>
              <p className="text-gray-400 text-center mb-4">
                Enter your 4 digit Password
              </p>
              <input
                type="password"
                placeholder="4-digit Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
              />
              <input
                type="password"
                placeholder=" Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full p-3 mb-4 bg-gray-900 text-white border border-gray-700 rounded-lg focus:ring focus:ring-gray-500"
              />
              <button
                onClick={reset}
                disabled={loading}
                className={`w-full py-3 rounded-lg transition ${
                  loading
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-black hover:bg-gray-700 text-white"
                }`}
              >
                {loading ? "Logging in..." : "Reset"}
              </button>
              {/* <p className="text-center mt-4">
                <a href="#" className="text-blue-400 hover:underline">
                  Forgot Password?
                </a>
              </p> */}
            </>
            )

            }
          </form>
        </div>
      </div>
    </div>
  );
};
